module.exports = __webpack_public_path__ + "static/media/Mahjong3d.23b3242b.jpg";